import React, {Component} from 'react';

import Input from 'Components/Input'
import Dropdown from 'Components/Dropdown';
import { ReactComponent as PlusIcon } from 'Icons/plus.svg';

import { PRICING_BASIS } from 'Constants/commonConstants';

class Costs extends Component {
    constructor(props) {
        super(props);
        this.costs = props.trip.costs;
        this.viewMode = props.viewMode;
        this.state = {
            costs: props.trip.costs,
        }
    }
    
    addCost = ()=>{
        if(this.viewMode) {
            return;
        }
        this.props.trip.addCost();
        this.setState({
            costs: this.props.trip.costs
        });
    }
    onChange = (index, e)=> {
        if(this.viewMode) {
            return;
        }
        const name = e.target.name;
        const value = e.target.value;
        this.costs[index]['set' + name.substr(0,1).toUpperCase() + name.slice(1) ](value);
        this.setState({
            costs: this.costs
        });
    }
    onSelect = (index, value, name)=> {
        if(this.viewMode) {
            return;
        }
        this.costs[index]['set' + name.substr(0,1).toUpperCase() + name.slice(1) ](value);
        this.setState({
            costs: this.costs
        });
    }
    render() {
        const { costs } = this.state;
        const { 
            pricingBasis
        } = this.props;
        return (
            <div className="">
                {
                    costs.map((cost, index)=> {
                        return (
                            <div key={index} className="border-status-bar br-5 pl-10 pr-10 pt-20 pb-20 mb-30">
                                <div className="fSemibold fs-18 header-medium-color mb-5">Cost Head</div>
                                <div className="wt-250 mb-30">
                                    <Input placeholder="Cost Head" value={cost.costHead} onChange={this.onChange.bind(this, index)} name="costHead"/>
                                </div>
                                <div className="fSemibold fs-18 header-medium-color mb-5">Cost Description</div>
                                <div className="col-1 mb-30">
                                    <textarea 
                                    placeholder="Describe The Cost" 
                                    value={cost.description} 
                                    onChange={this.onChange.bind(this, index)} 
                                    name="description"
                                    className="pl-10 pt-10 fs-16 border-light ht-80 col-1 br-5"
                                    />
                                </div>

                                <div className="flex mb-30">
                                    <div className="wt-150 mr-20">
                                        <div className="fSemibold fs-18 header-medium-color mb-5">MR</div>
                                        <div className="wt-150">
                                            <Input placeholder="MR" value={cost.mr} onChange={this.onChange.bind(this, index)} name="mr"/>
                                        </div>
                                    </div>
                                    <div className="wt-150">
                                        <div className="fSemibold fs-18 header-medium-color mb-5">LPP</div>
                                        <div className="wt-150">
                                            <Input placeholder="LPP" value={cost.lpp} onChange={this.onChange.bind(this, index)} name="lpp"/>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex">
                                    <div className="wt-150 mr-20">
                                        <div className="fSemibold fs-18 header-medium-color mb-5">CP</div>
                                        <div className="wt-150">
                                            <Input placeholder="MR" value={cost.cp} onChange={this.onChange.bind(this, index)} name="cp"/>
                                        </div>
                                    </div>
                                    <div className="wt-150">
                                        <div className="fSemibold fs-18 header-medium-color mb-5">Currency</div>
                                        <Dropdown 
                                            items={pricingBasis} 
                                            selectedItem={pricingBasis.find(pricingBasis=>{return cost.currency === pricingBasis.value})}
                                            name="currency"
                                            onSelect={this.onSelect.bind(this, index)}
                                            displayKey="name"
                                            className="flex-1"
                                            label="Select unit"
                                        />
                                    </div>
                                </div>
                             </div>
                        )   
                    })
                }
                <div className="flex flex-middle curP mt-30" onClick={this.addCost}>
                    <div className="flex flex-middle flex-center bg-theme wt-25 ht-25 br-20 border-none br-50p mr-5">
                        <PlusIcon className="wt-15 ht-15"/>
                    </div>
                    <div className="fSemibold fs-16 fBold header-dark-color">Add Cost</div>
                </div>
            </div>
        )
    }
}

export default Costs;
